import { render, staticRenderFns } from "./ContactThankYouPending.vue?vue&type=template&id=09318614&scoped=true"
import script from "./ContactThankYouPending.vue?vue&type=script&lang=js"
export * from "./ContactThankYouPending.vue?vue&type=script&lang=js"
import style0 from "./ContactThankYouPending.vue?vue&type=style&index=0&id=09318614&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09318614",
  null
  
)

export default component.exports